import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PinDropOutlinedIcon from "@mui/icons-material/PinDropOutlined";
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined";
import Box from "@mui/material/Box";
import { useState } from "react";
import { TextInput } from "./Input";
import { MaskInput } from "./MaskInput";
import { PrimaryButton } from "./PrimaryButton";
import axios, { AxiosRequestConfig } from "axios";
import { AppContext } from "../context";
import { useContext } from "react";
import { useHistory } from "react-router-dom";
import AlertField from "./Alert";


export const AddressForm = () => {
  const { updateLead } = useContext<any>(AppContext);
  const [street, setStreet] = useState("");
  const history = useHistory();
  const [openAlert, setOpenAlert] = useState<boolean>(false)
  const [alertMessage, setAlertMessage] = useState<string>('')
  const [open, setOpen] = useState(false);

  

  const handleCep = async (e: any) => {
    const cep = e.replace(/\D/g, "")
    if (cep.length === 8) {
      const url = `https://brasilapi.com.br/api/cep/v2/${cep}`;
      const config: AxiosRequestConfig = {
        method: "POST",
        url: url,
      };
      const res = await axios(config);
      console.log(res.data);
      if(res.data.street) {
        setStreet(res.data.street);
      }
    }
  };

  const handleClickOpen =  () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpenAlert(false)
  }
  
  const handleSubmit = (e: any) => {
    e.preventDefault() 

    const data = {
      address_cep: e.target?.cep.value,
      address_street: street,
      address_number: e.target?.number.value,
      address_complement: e.target?.complement.value,
    };
    console.log(data);
    if (!data.address_cep) {
      setAlertMessage('CEP não informado!')
      setOpenAlert(true)
    } else if (!data.address_street) {
      setAlertMessage('Endereço não informado!')
      setOpenAlert(true)
    } else if (!data.address_number) {
      setAlertMessage('Número não informado!')
      setOpenAlert(true)
    } else {
      const res = updateLead(data);
      if (res) {
        history.push("/contato");
      }
      
    };
    }

  return (
    <Box
      style={{ width: "100vw" }}
      sx={{
        marginTop: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <form onSubmit={handleSubmit}>
      <Box sx={{ display: "flex", alignItems: "flex-end" }}>
          <AlertField message={alertMessage} status={openAlert} handle={handleClose} />
        </Box>
        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
          <MapOutlinedIcon sx={{ color: "#656565", mr: 1, my: 1.5 }} />
          <MaskInput
            mask="99.999-999"
            id="cep"
            label="CEP"
            handle={handleCep}
          />
        </Box>
        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
          <HomeOutlinedIcon sx={{ color: "#656565", mr: 1, my: 1.5 }} />
          <TextInput id="street" label="Rua" value={street} handle={setStreet}/>
        </Box>
        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
          <PinDropOutlinedIcon sx={{ color: "#656565", mr: 1, my: 1.5 }} />
          <TextInput id="number" label="Número" />
        </Box>
        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
          <ApartmentOutlinedIcon
            sx={{ color: "#656565", mr: 1, my: 1.5 }}
          />
          <TextInput id="complement" label="Complemento" />
        </Box>
        <Box sx={{ display: "flex", alignItems: "flex-end" }}>
          <PrimaryButton name="Prosseguir" />
        </Box>
      </form>
    </Box>
  );
};
